import { first } from 'rxjs'
import { Component, Input, OnInit } from '@angular/core'
import { ModalController } from '@ionic/angular'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { environment } from 'src/environments/environment'
import { Storage } from '@ionic/storage-angular'
import { ValidationService } from '@services/utils/validations/validation.service'
import { AddressService } from '@services/catalogs/address/address.service'
import { AlertService } from '@services/utils/alerts/alert.service'
import { ValidationMessages } from '@services/utils/validations/validation-messages.service'
import { EndpointsService } from '@services/api/endpoints.service'
import { ApiService } from '@services/api/api.service'

@Component({
  selector: 'app-address-detail',
  templateUrl: './address-detail.page.html',
  styleUrls: ['./address-detail.page.scss']
})
export class AddressDetailPage implements OnInit {
  updateForm: FormGroup
  addressRegister: any
  title: string = 'La dirección'
  @Input() data: any
  validationMessages = this.validationMessagesLoad.validationMessages
  currentCharCount: number = 0

  id_country
  states = []
  cities = []
  status_city: boolean = true
  statusForm = false
  isFirstTime = true

  userInfo
  filteredOptions: string[] = []

  portControl: FormControl
  url = this.endpointsService.url
  constructor(
    public endpointsService: EndpointsService,
    public apiService: ApiService,
    public alertService: AlertService,
    public addressService: AddressService,
    public validationService: ValidationService,
    public validationMessagesLoad: ValidationMessages,
    public modalController: ModalController,
    public formBuilder: FormBuilder,
    public storage: Storage
  ) {}

  ngOnInit() {
    this.validateForm()
    this.loadStates()
    this.storage.get(environment.localStorage).then((data) => {
      if (data != null) {
        this.userInfo = data
      }
    })
    this.updateCharCount()
  }

  loadStates() {
    this.apiService
      .getAll(this.url.state)
      .pipe(first())
      .subscribe(
        (res) => {
          // Filtrar solo estados activos
          this.states = res.filter((obj) => {
            return obj.active
          })

          // Buscar el estado de la dirección en todos los resultados
          let existingState = res.find((obj) => obj.id == this.data.state_id)

          // Si existe pero no está activo, agregarlo a la lista
          if (existingState && !existingState.active) {
            this.states.push(existingState)
          }

          // Si no existe en absoluto, crear uno temporal
          if (!existingState && this.data.state_name) {
            existingState = {
              id: `temp_${this.data.state_name}`,
              name: this.data.state_name,
              active: false
            }
            this.states.push(existingState)
          }

          // Preseleccionar el estado
          if (existingState) {
            this.updateForm.controls['state_id'].setValue(existingState)
          }

          this.loadCities()
        },
        (err) => {}
      )
  }

  onStateChange() {
    // Marcar que ya no es la primera vez para no agregar ciudades temporales
    this.isFirstTime = false
    // Limpiar la ciudad seleccionada
    this.updateForm.controls['city_id'].setValue(null)
    this.loadCities()
  }

  loadCities() {
    let data = this.updateForm.controls
    if (!data.state_id.value || !data.state_id.value.id) {
      return
    }
    
    let state = data.state_id.value.id

    // Si el estado es temporal (string), no cargar ciudades del API
    if (typeof state === 'string' && state.startsWith('temp_')) {
      this.cities = []
      // Solo crear ciudad temporal en la primera carga
      if (this.isFirstTime && this.data.city_name) {
        const tempCity = {
          id: `temp_${this.data.city_name}`,
          name: this.data.city_name,
          state_id: state,
          active: false
        }
        this.cities.push(tempCity)
        this.updateForm.controls['city_id'].setValue(tempCity)
      }
      this.status_city = false
      this.isFirstTime = false
      return
    }

    this.apiService
      .getAll(this.url.city)
      .pipe(first())
      .subscribe(
        (res) => {
          // Filtrar solo ciudades activas del estado
          this.cities = res.filter((obj) => {
            return obj.active && obj.state_id == state
          })

          let selectedCity = null

          // Solo buscar y agregar ciudades inactivas/temporales en la primera carga
          if (this.isFirstTime) {
            // Buscar la ciudad de la dirección en todos los resultados
            selectedCity = res.find((obj) => 
              obj.state_id == state && 
              obj.id == this.data.city_id
            )

            // Si existe pero no está activa, agregarla a la lista
            if (selectedCity && !selectedCity.active) {
              this.cities.push(selectedCity)
            }

            // Si no existe en absoluto, crear una temporal
            if (!selectedCity && this.data.city_name) {
              selectedCity = {
                id: `temp_${this.data.city_name}`,
                name: this.data.city_name,
                state_id: state,
                active: false
              }
              this.cities.push(selectedCity)
            }

            // Preseleccionar la ciudad
            if (selectedCity) {
              this.updateForm.controls['city_id'].setValue(selectedCity)
            }

            this.isFirstTime = false
          }

          this.status_city = false
        },
        (err) => {}
      )
  }

  async update() {
    if (!this.updateForm.valid) {
      this.updateForm.markAllAsTouched()
      this.alertService.errorFields()
    } else {
      this.alertService.presentLoading()

      await this.addressService
        .update(this.getData())
        .pipe(first())
        .subscribe(
          (res) => {
            this.alertService.dismiss().then(() => {
              this.success(res)
            })
          },
          (err) => {
            this.data.id == undefined
          }
        )
      this.closeModal()
    }
  }

  getData = function () {
    let data = this.updateForm.controls
    this.addressRegister = {
      identification_user: this.userInfo.email,
      id: this.data.id,
      address: data.address.value,
      postal: data.postal.value,
      observation: data.observation.value,
      state_id: data.state_id.value.id,
      city_id: data.city_id.value.id,
      institution_name: data.institution.value,
      active: data.active.value == 1 ? true : false
    }

    return this.addressRegister
  }

  success(res) {
    this.alertService.statusSuccessUpdate(this.title)
  }

  validateForm() {
    this.updateForm = this.formBuilder.group({
      address: [
        this.data.address,
        [this.validationService.Validation(3, 51, 'anyText')]
      ],
      observation: [
        this.data.observation,
        [this.validationService.Validation(3, 201, 'anyText', false)]
      ],
      state_id: [24, Validators.compose([Validators.required])],
      city_id: [
        {
          value: ''
        },
        Validators.compose([Validators.required])
      ],
      institution: [
        this.data.institution_name,
        [this.validationService.Validation(3, 51, 'anyText')]
      ],
      active: [this.data.active, Validators.compose([Validators.required])],
      postal: [
        this.data.postal,
        [this.validationService.Validation(3, 9, 'onlyNumbersText', false)]
      ]
    })
  }

  updateCharCount() {
    const observationValue = this.updateForm?.get('observation')?.value || '';
    this.currentCharCount = observationValue.length;
  }

  closeModal(id?) {
    this.modalController.dismiss(id ? undefined : this.data.id)
  }

  get errorControl() {
    return this.updateForm.controls
  }
}
